import type { ITimelineState } from './types';

export const state: ITimelineState = {
  cards: [],
  alerts: [],
  hasMoreCards: true,
};
